import { useEffect } from "react"

import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom"

import { useGetEnabledModulesInApp } from "@l2r-front/l2r-networks"

import { appCity } from "../../constants/appCity"
import { CityDesktopLayout } from "../../layouts/CityDesktopLayout"

export function CityDesktopRouter() {

    const enabledCityModule = useGetEnabledModulesInApp(appCity)
    const location = useLocation()
    const matchEnabledModule = enabledCityModule?.find(m => location.pathname.includes(m.path))
    const navigate = useNavigate()

    useEffect(() => {
        if (!matchEnabledModule) {
            navigate(`${enabledCityModule?.[0]?.path || ""}`)
        }
    }, [enabledCityModule, matchEnabledModule, navigate])

    return (
        <Routes>
            <Route
                path="/*"
                element={
                    <CityDesktopLayout />
                }
            />
            <Route
                path="/"
                element={
                    <Navigate replace to={enabledCityModule?.[0]?.path ? enabledCityModule?.[0]?.path : ""} />
                }
            />
        </Routes>
    )
}